import React, { useState } from 'react';
import './GallerySection.css';

// Attempt to import images. If an image doesn't exist, the build will fail for that import.
// You can add more imports here following the pattern if you have more than 6 images.
// Ensure your images are named 1.jpg, 2.jpg, etc., in the src/assets/gallery/ folder.
let imagesToDisplay = [];
try {
  imagesToDisplay.push({ src: require('../assets/gallery/1.jpg'), alt: 'Vista de la plataforma ThinkHealth 1' });
} catch (e) { console.warn("Could not load image 1.jpg from gallery"); }
try {
  imagesToDisplay.push({ src: require('../assets/gallery/2.jpg'), alt: 'Interfaz de consulta IA 2' });
} catch (e) { console.warn("Could not load image 2.jpg from gallery"); }
try {
  imagesToDisplay.push({ src: require('../assets/gallery/3.jpg'), alt: 'Videollamada con especialista 3' });
} catch (e) { console.warn("Could not load image 3.jpg from gallery"); }
try {
  imagesToDisplay.push({ src: require('../assets/gallery/4.jpg'), alt: 'Integración con Grehta.org 4' });
} catch (e) { console.warn("Could not load image 4.jpg from gallery"); }
try {
  imagesToDisplay.push({ src: require('../assets/gallery/5.png'), alt: 'Historial clínico inteligente 5' });
} catch (e) { console.warn("Could not load image 5.jpg from gallery"); }
try {
  imagesToDisplay.push({ src: require('../assets/gallery/6.jpg'), alt: 'Aplicación móvil ThinkHealth 6' });
} catch (e) { console.warn("Could not load image 6.jpg from gallery"); }


const GallerySection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const openModal = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
  };

  if (imagesToDisplay.length === 0) {
    // Fallback if no images are loaded, to prevent errors and inform the user
    return (
      <section id="gallery" className="gallery-section">
        <div className="gallery-background">
          <div className="gallery-orb gallery-orb-1"></div>
          <div className="gallery-orb gallery-orb-2"></div>
          <div className="gallery-orb gallery-orb-3"></div>
        </div>
        
        <div className="container">
          <h2 className="section-title">Galería de Imágenes</h2>
          <p className="section-subtitle">
            Un vistazo a nuestra plataforma de IA, la asistencia virtual y nuestra colaboración con expertos.
          </p>
          <div className="gallery-grid">
            <div className="image-placeholder-message">
              <p>No se encontraron imágenes en la galería.</p>
              <small>Por favor, asegúrate de colocar imágenes numeradas (1.jpg, 2.jpg, etc.) en la carpeta <code>src/assets/gallery/</code>.</small>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="gallery" className="gallery-section">
      <div className="gallery-background">
        <div className="gallery-orb gallery-orb-1"></div>
        <div className="gallery-orb gallery-orb-2"></div>
        <div className="gallery-orb gallery-orb-3"></div>
      </div>
      
      <div className="container">
        <h2 className="section-title">Galería de Imágenes</h2>
        <p className="section-subtitle">
          Un vistazo a nuestra plataforma de IA, la asistencia virtual y nuestra colaboración con expertos.
        </p>
        <div className="gallery-grid">
          {imagesToDisplay.map((image, index) => (
            <div key={index} className="gallery-item" onClick={() => openModal(image)}>
              <img src={image.src} alt={image.alt} />
            </div>
          ))}
        </div>
        {imagesToDisplay.length < 6 && (
           <p className="gallery-note">
            Puedes agregar más imágenes (hasta 6 configuradas por defecto) nombrándolas secuencialmente (1.jpg, 2.jpg, ...) en la carpeta <code>src/assets/gallery/</code>.
            Si deseas mostrar más, necesitarás actualizar el código en <code>GallerySection.js</code>.
          </p>
        )}
      </div>

      {isModalOpen && currentImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-button" onClick={closeModal}>&times;</button>
            <img src={currentImage.src} alt={currentImage.alt} className="modal-image" />
            <p className="modal-caption">{currentImage.alt}</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
